<template>
  <div>
    <b-row>
      <b-col class="text-center mt-3"><h4>Veuillez sélectionner une option</h4></b-col>
    </b-row>
    <b-row v-if="displayZipBackupOption">
      <b-col class="text-center mt-3">
        <h5>Vous souhaitez créer et envoyer un fichier zip de la réunion à l'agence ?</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="!displayZipBackupOption" class="text-center my-4">
        <b-button class="mr-5" variant="primary" @click="archiveMeeting">Archiver</b-button>
        <b-button class="ml-5" variant="secondary" @click="deleteMeeting">Supprimer</b-button>
      </b-col>
      <b-col v-if="displayZipBackupOption" class="text-center my-4">
        <b-button class="mr-5" variant="success" @click="deleteMeetingOption(true)">Oui</b-button>
        <b-button class="ml-5" variant="danger" @click="deleteMeetingOption(false)">Non</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      displayZipBackupOption: false,
    };
  },
  created() {
    // Archived meeting can be deleted
    if (this.meeting.status == this.meetingStatuses.archived) {
      this.displayZipBackupOption = true;
    }
  },
  methods: {
    deleteMeeting() {
      this.displayZipBackupOption = true;
    },
    deleteMeetingOption(doZipBackup) {
      if (doZipBackup != null) {
        this.$emit("delete", doZipBackup);
      }
    },
    archiveMeeting() {
      this.$emit("archive");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
